import { render, staticRenderFns } from "./ModalVerParticipantes.vue?vue&type=template&id=a9bc2e70"
import script from "./ModalVerParticipantes.vue?vue&type=script&lang=js"
export * from "./ModalVerParticipantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports